import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      d: "M12.83 9.837a1.48 1.48 0 0 0-2.088 0l-.35.355a.92.92 0 0 1-1.168.111 13.4 13.4 0 0 1-3.526-3.526.92.92 0 0 1 .111-1.168l.356-.351a1.483 1.483 0 0 0 0-2.088l-.745-.74c-.573-.578-1.51-.578-2.113.03-1.524 1.523-1.742 3.885-.514 5.618a21.5 21.5 0 0 0 5.13 5.13c.753.531 1.621.792 2.494.792 1.13 0 2.263-.44 3.123-1.305l.03-.03a1.48 1.48 0 0 0 0-2.084z"
    }, null, -1)
  ])))
}
export default { render: render }